import Cookies from 'js-cookie';

export function sessionCount() {
  let curSessionCount = 0;

  if (Cookies.get('sm-sc')) {
    curSessionCount = Cookies.get('sm-sc');
  }

  return curSessionCount;
}

export function sessionPageCount() {
  let pageCount = 0;

  if (Cookies.get('sm-pc')) {
    pageCount = Cookies.get('sm-pc');
  }

  return pageCount;
}

// How long has the current session been going
export function sessionDurationInSeconds() {
  const sessionStart = Cookies.get('sm-ss');

  const now = new Date().getTime();

  let lastSeenInSeconds = null;

  lastSeenInSeconds = (Math.abs(sessionStart - now) / 1000);

  return lastSeenInSeconds;
}

// Set new user cookie
export function setNewUser() {
  const twoYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 2));

  Cookies.set('sm-nu', true, { expires: twoYearsFromNow });
}

// Save returning user cookie
export function setReturningUser() {
  const twoYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 2));

  Cookies.remove('sm-nu');
  Cookies.set('sm-ru', true, { expires: twoYearsFromNow });
}

// Are they a new user?
export function isNewUser() {
  return Cookies.get('sm-nu');
}

// Are they a returning user?
export function isReturningUser() {
  return Cookies.get('sm-ru');
}

// TODO: ES-1570 These sstk functions might be moved somewhere else when SSTK stuff is set up?
// Register that they clicked sstk in this session
export function registerSessionSSTKClick() {
  const twoYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 2));

  window.clickedSSTKThisPage = true;

  Cookies.set('sm-sstk', true, { expires: twoYearsFromNow });
}

// Have they clicked sstk in this session?
export function sessionSSTKClick() {
  if (Cookies.get('sm-sstk')) {
    return true;
  }
  return false;
}

export function saveLocalToCookie(key) {
  if (localStorage.getItem(key)) {
    Cookies.set(key, localStorage.getItem(key));
  }
}

export function saveToLocalAndCookie(key, value) {
  localStorage.setItem(key, value);
  Cookies.set(key, value);
}

export function sessionMetaData() {
  const metadata = {};

  metadata.sessionDurationInSeconds = sessionDurationInSeconds();
  metadata.sessionCount = sessionCount();
  metadata.sessionPageCount = sessionPageCount();
  metadata.isReturningUser = isReturningUser();
  metadata.isNewUser = isNewUser();
  metadata.sessionSSTKClick = sessionSSTKClick();
  metadata.most_recent_search = Cookies.get('most_recent_search');
  metadata.most_recent_resource_id = Cookies.get('most_recent_resource_id');

  return metadata;
}
